import { render, staticRenderFns } from "./TagPropagateModal.vue?vue&type=template&id=14edbfbc"
import script from "./TagPropagateModal.vue?vue&type=script&lang=js"
export * from "./TagPropagateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports